import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import getInfoByTVM from "../../../api/Commands/getInfoByTVM";
import GeneralTable from "../../../Hooks/Table/GeneralTable";
import { Box } from "@mui/material";

function CommandsAdditionalModal({ show, onHide, commandId, setIsLoading }) {
    const language = JSON.parse(localStorage.getItem('language'));
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const currentTenant = currentUser.data.currentTenant;
    const languageCode = currentUser.data.userData.languageCode;
    const [commandInfo, setCommandInfo] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                setIsLoading(true);
                const data = await getInfo();
                setCommandInfo([data.data]);
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchData();
    }, [commandId]);

    async function getInfo() {
        const { data, error } = await getInfoByTVM(commandId, currentTenant);

        if (error !== undefined) {
            console.error(error);
            return [];
        } else {
            return data;
        }
    };

    const columns = [
        {
            header: language.TVM,
            accessorKey: 'TVM'
        },
        {
            header: language.Station,
            accessorKey: 'stationName'
        },
        {
            header: language.Received,
            accessorKey: 'received',
            Cell: ({ renderedCellValue }) => (
                <Box>
                    <img src={renderedCellValue === 1 ? './img/icons/pages/CheckMark.svg' : './img/icons/pages/CroseMark.svg'}
                        className='table__checkbox' />
                </Box>
            )
        },
        {
            header: language.Date,
            accessorKey: 'dateTime',
            Cell: ({ renderedCellValue }) => (
                <div>{new Date(renderedCellValue).toLocaleString(languageCode)}</div>
            ),
        },
        {
            header: language.Message,
            accessorKey: 'message'
        }
    ];

    const handleClose = () => {
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered dialogClassName="custom-modal">
            <Modal.Body>
                {(commandInfo?.length > 0) && <GeneralTable data={commandInfo} columns_table={columns} disableBars={true} />}
            </Modal.Body>

            <Modal.Footer>
                <Button className="general-button danger" onClick={handleClose}>
                    {language.Close}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CommandsAdditionalModal;